export class InterfaceUtil {
    static isSliceAction(action) {
        return typeof action.type === "string" && typeof action.slice === "string";
    }
    static isReduceableAction(action) {
        return (InterfaceUtil.isSliceAction(action) && typeof action.reduce === "function");
    }
    static isHydratableReducer(reducer) {
        return (typeof reducer.reduce === "function" &&
            typeof reducer.rehydrate === "function" &&
            typeof reducer.dehydrate === "function");
    }
}
